module.exports = __webpack_public_path__ + "static/media/TD.82e99a5a.png";